import React from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { reminderChannels, reminderCountOptions, reminderCustomOptions, reminderOptions } from 'constants/dropdownOptions';
import { FormLabel } from 'modules/automation/WorkflowBuilder/components';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

function TaskReminder({ isRequired, optionText = '', index: mainIndex }) {
  const {
    watch,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { fields, insert, remove } = useFieldArray({
    control,
    name: `actions.${mainIndex}.reminders`,
    rules: {
      validate: (value) => ((value && value.length > 0) || !isRequired ? true : 'Please add at least one reminder.'),
    },
  });

  function onAddReminder() {
    insert(fields.length, { value: '30#minutes#', reminder_channel_type: 'inapp_notification' });
  }
  function onDeleteReminder(index) {
    remove(index);
  }

  return (
    <div className="d-flex flex-wrap w-100 pb-2">
      <FormLabel label="Reminders" isRequired={isRequired} className="p-medium" />

      <div className="w-100">
        {fields?.length > 0 &&
          fields.map((data, index) => {
            let reminderValue = watch(`actions.${mainIndex}.reminders.${index}.value`);
            return (
              <div
                className="d-flex bg-card rounded card-bg-color align-items-center justify-content-center p-2 mb-2 bg-grey mt-2"
                key={data.id}
              >
                <div className="w-100">
                  <div className="d-flex align-items-center gap-3">
                    <Controller
                      name={`actions.${mainIndex}.reminders.${index}.reminder_channel_type`}
                      rules={{ required: 'Channel is required' }}
                      control={control}
                      render={({ field }) => (
                        <Dropdown
                          placeholder="Channel"
                          name={field.name}
                          id={field.name}
                          value={field.value}
                          onChange={(e) => field.onChange(e.value)}
                          options={reminderChannels}
                          className="w-100"
                          filter
                          inputRef={field.ref}
                        />
                      )}
                    />
                    <Controller
                      name={`actions.${mainIndex}.reminders.${index}.value`}
                      control={control}
                      rules={{ required: 'Value is required' }}
                      render={({ field }) => (
                        <Dropdown
                          placeholder="Add"
                          name={field.name}
                          id={field.name}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                            if (e.value === 'custom') {
                              setValue(`actions.${mainIndex}.reminders.${index}.customValue`, 1);
                              setValue(`actions.${mainIndex}.reminders.${index}.minutes`, 'minutes');
                              setValue(`actions.${mainIndex}.reminders.${index}.type`, 'minutes');
                              setValue(`actions.${mainIndex}.reminders.${index}.past_due`, '');
                            } else {
                              setValue(`actions.${mainIndex}.reminders.${index}.customValue`, null);
                              setValue(`actions.${mainIndex}.reminders.${index}.minutes`, null);
                              setValue(`actions.${mainIndex}.reminders.${index}.type`, null);
                              setValue(`actions.${mainIndex}.reminders.${index}.past_due`, null);
                            }
                          }}
                          options={reminderOptions?.map((item) => ({
                            ...item,
                            label: item?.value === 'custom' ? item.label : `${item?.label} ${optionText}`,
                          }))}
                          className="w-100"
                          filter
                          inputRef={field.ref}
                        />
                      )}
                    />
                  </div>

                  {reminderValue === 'custom' && (
                    <div className="d-flex mt-2 gap-3">
                      <Controller
                        name={`actions.${mainIndex}.reminders.${index}.customValue`}
                        control={control}
                        defaultValue={1}
                        render={({ field }) => (
                          <Dropdown
                            placeholder="Add"
                            name={field.name}
                            id={field.name}
                            className="w-100"
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            options={reminderCountOptions}
                            filter
                            inputRef={field.ref}
                          />
                        )}
                      />

                      <Controller
                        name={`actions.${mainIndex}.reminders.${index}.type`}
                        control={control}
                        defaultValue="minutes"
                        render={({ field }) => (
                          <Dropdown
                            placeholder="Select Type"
                            className="w-100"
                            name={field.name}
                            id={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            options={reminderCustomOptions}
                            filter
                            inputRef={field.ref}
                          />
                        )}
                      />
                    </div>
                  )}
                  <RequiredValidation errors={errors} field={`actions.${mainIndex}.reminders.${index}.value`} />
                  <RequiredValidation errors={errors} field={`actions.${mainIndex}.reminders.${index}.reminder_channel_type`} />
                </div>
                <Button
                  tooltip="Delete Reminder"
                  tooltipOptions={{ showDelay: 500, position: 'left' }}
                  icon="pi pi-trash danger-text"
                  className="p-button-rounded p-button-text text-danger p-3"
                  onClick={() => onDeleteReminder(index)}
                />
              </div>
            );
          })}
        <div className="mt-2 ">
          <span className="pointer call-back" onClick={onAddReminder}>
            + Add Reminder
          </span>
        </div>
      </div>
      <div className="offset-md-4">
        {errors?.actions?.[mainIndex]?.reminders?.validate && (
          <RequiredValidation errors={errors} field={`actions.${mainIndex}.reminders`} message="At least one reminder is required" />
        )}
      </div>
    </div>
  );
}

export default TaskReminder;
